/* eslint-disable import/no-anonymous-default-export */
import { Button, Collapse, Form, Input, InputNumber, Modal, notification, Select, Space, Table, Typography } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import moment from "moment";
import { FilePdfOutlined, DownloadOutlined, PrinterOutlined, SendOutlined } from '@ant-design/icons';
import { useEffect, useRef, useState } from "react";
import DataFilter from "../common/components/DataFilter";
import DataTable, { DataTableRef } from "../common/components/DataTable";
import MainLayout from "../common/components/MainLayout";
import useInfraccionesRadarAPI, { FilterReincidenciaProps } from "../infracciones/hooks/useInfraccionesAPI";
import FiltroInfracciones, { FiltroInfraccionesRef } from "../infracciones/components/FiltroInfracciones";
import { ActionResult, Query } from "../common/hooks/useApi";
import useAgentesAPI, { Agente } from "../agentes/useAgentesAPI";
import useLotesImpresionAPI, { EmpresaCorreo, LoteImpresion } from "./useLotesImpresionAPI";
import LoteImpresionCheck, { LoteImpresionCheckRef } from "./components/LoteImpresionCheck";
import { AxiosError } from "axios";
import { TipoExportacion } from "../configuraciones-produccion/useConfiguracionesProduccionAPI";
import styled from "styled-components";
import { toInteger } from "lodash";
import useUtils from "../common/hooks/useUtils";
import { useForm } from "antd/lib/form/Form";
import { UnidadProduccion } from "../unidades-produccion/useUnidadesProduccionAPI";
import ModalElegirDescarga from "./components/ModalDescargarPorSeleccion";

const StyledModal = styled(Modal)`
display:flex;
justify-content:center;
`;

const FiltroReincidencia = styled.div`
display: grid;
grid-template-columns: 1fr 1fr;
grid-gap: 1rem;
`;

const ImpresionesStyled = styled.div`
text-align: center;
&.green {
        color: green;
    }
&.red {
        color: red;
    }
&.blue {
        color: #2471a3;
    }
`;

const DataTableStyled = styled.div`  
  table
  {
    min-width:1000px!important;
  }
  .status-color
  {
    td
    {        
        color:black;
    }    
    &.green td {
        background-color: #91FF7F;
    }    
    &.white td {
        background-color: white;
    }
  }
`;

export default () => {
    const api = useLotesImpresionAPI();
    const apiInfraccionesImpresion = useInfraccionesRadarAPI()
    const apiAgentes = useAgentesAPI();
    const { getProvinciasList } = useUtils();
    const [form] = useForm<FilterReincidenciaProps>();

    const [agentesResponse, setAgentesResponse] = useState<ActionResult<Agente[]>>();
    const [empresasCorreoResponse, setEmpresasCorreoResponse] = useState<any>();
    const [selectedUnidadesProduccion, setSelectedUnidadesProduccion] = useState<any>([]);
    const infraccionesRadarApi = useInfraccionesRadarAPI();
    const refFiltroInfracciones = useRef<FiltroInfraccionesRef>(null!);
    const refTable = useRef<DataTableRef>(null!);
    const refCheckLote = useRef<LoteImpresionCheckRef>(null!);

    const [agenteFirmanteId, setAgenteFirmanteId] = useState<number>();
    const [empresaCorreoId, setEmpresaCorreoId] = useState<number>();
    const [query, setQuery] = useState<Query>();
    const [total, setTotal] = useState<number>();
    const [loading, setLoading] = useState(false);
    const [loadingImportPDF, setLoadingImportPDF] = useState(false);
    const [nroLoteFilterForm] = Form.useForm();
    const [uProduccionFilterForm] = Form.useForm();
    const [isModalImpresionCheckVisible, setIsModalImpresionCheckVisible] = useState<boolean>(false)
    const [preFiltro, setPreFiltro] = useState<number | null>(null);
    const [filtersReincidencia, setfiltersReincidencia] = useState<FilterReincidenciaProps | null>(null)
    const [infraccionesIds, setInfraccionesIds] = useState<number[]>([]);
    const [unidadesProdNombres, setUnidadesProdNombres] = useState<any>([]) 
    //Variables para modal de descarga por parametro
    const [isModalElegirDescarga, setIsModalElegirDescarga] = useState<boolean>(false);
    const [loteImpresionId, setLoteImpresionId] = useState<number|null>(null);

    const queryImportPdf = async (data: { tipoImportacion: TipoExportacion }) => {

        setLoadingImportPDF(true);
        const response = await api.importPDF(data.tipoImportacion)
        setLoadingImportPDF(false);

        if (response.error && response.error.response.status) {
            const error = response.error as AxiosError;

            notification.error({
                message: [400, 404].includes(error.response?.status ?? 0)
                    ? error.response?.data
                    : "Error al cargar los datos",
            });
        } else if (response.error) {
            notification.error({ message: "Error al cargar los datos" });
        } else {
            notification.success({ message: "Datos cargados correctamente" });
        }

    }

    const downloadPrinter = async () => {
        const response = await api.downloadPrinter();
        if (response.error) {
            notification.error({
                message: 'Error al descargar el impresor'
            })
            return;
        }

        window.location.href = response.data?.value!;
    }

    useEffect(() => {
        if (localStorage.getItem('agentePreseleccionado')) {
            try {
                let agentePreselec = JSON.parse(localStorage.getItem('agentePreseleccionado')!);
                setAgenteFirmanteId(agentePreselec);
            }
            catch (e) { }
        }

        apiAgentes.list({}).then(setAgentesResponse);
        localStorage.removeItem('agentePreseleccionado')
        api.getEmpresasCorreo().then(setEmpresasCorreoResponse);
    }, [])

    const generateFilters = (filters: Record<string, FilterValue | null>) => {
        //debugger
        //console.log(filters)
        return [
            filters?.NroLote != null ? `NroLote eq ${filters!.NroLote![0]}` : "",
            filters?.UnidadesProdNombre != null ? `contains(UnidadesProdNombre,'${filters!.UnidadesProdNombre![0]}')` : "",

        ];
    }

    const genStrongText = (text: string) => (
        <strong>{text}</strong>
    );

    const onChangePreFiltro = async (value?: number) => {
        setPreFiltro(value!)
        if (preFiltro === 1) {
            const filterReincidenciaEntrerrianos = {
                "LimiteInfraccionesTotal": 4, "DiasPeriodo": 90, "LimiteInfraccionesPeriodo": 2, "ProvinciaTitular": "ENTRE RIOS"
            }
            setfiltersReincidencia(filterReincidenciaEntrerrianos);
            form.setFieldsValue(filterReincidenciaEntrerrianos);
        }
    }

    const sendLoteToCallCenter = async (id: number) => {
        try {
            await api.sendLoteImpresionToCallCenter(id);
            await refTable.current.loadItems();
            notification.success({ message: 'Lote enviado a Call Center correctamente..' })
        } catch (error) {
            console.log(error)
            return;
        }
    }

    useEffect(() => {
        onChangePreFiltro();
    }, [preFiltro])

    useEffect(() => {
        refFiltroInfracciones.current?.loadTotal();
    }, [filtersReincidencia]);

    useEffect(() => {
        if (selectedUnidadesProduccion.length === 0) {
            apiAgentes.list({}).then(setAgentesResponse);
            return;
        }
        const unidadesProduccionIds = selectedUnidadesProduccion.map((unidad: UnidadProduccion) => unidad.Id);
        const filterString = unidadesProduccionIds.map((id: number) => `UnidadProduccionAgenteId eq ${id}`).join(" or ");

        apiAgentes.list({ $filter: [filterString] }).then(setAgentesResponse);

        const unidadesProduccionNombres = selectedUnidadesProduccion.map((unidad: UnidadProduccion) => unidad.Nombre);
        setUnidadesProdNombres(unidadesProduccionNombres)
    }, [selectedUnidadesProduccion]);    

    const handleChangeColorRow = (model: LoteImpresion) => {        
        let color;        
        if (model.DisponibleCallcenter === true) {
            color = "green";           
        }
        else {
            color = "white";
        }
        return color;
    }
    const onRowClassName = (model: LoteImpresion, rowNumber: number) => {
        return `status-color ${handleChangeColorRow(model)}`;
    };

    const descargarActasSeleccion = async (seleccion:any, soloTxt: boolean, soloPdf:boolean) => {
        const direccionQuery = `(Titular/DireccionCompletaTitular ne null and (contains(Titular/DireccionCompletaTitular, 'S/N') or contains(Titular/DireccionCompletaTitular, 'SIN DIRECCION')) or contains(Titular/CodigoPostalTitular, '9999'))`;
        let options = seleccion.map((e: number) => {
            switch(e){
                case 1: return `(contains(Titular/TelefonosCelulares, '4') or contains(Titular/TelefonosCelulares, '5') or contains(Titular/TelefonosCelulares, '6'))`;
                case 2: return `(Titular/Emails ne null and length(Titular/Emails) gt 0 and contains(Titular/Emails, '@'))`;
                case 3: return `(EstadoPago eq 'IMPAGA')`;
                case 4: return direccionQuery;
                case 5: return `(not ${direccionQuery})`;
                case 6: return `(substring(Titular/CuilTitular,0,2) eq '30' or substring(Titular/CuilTitular,0,2) eq '33' or substring(Titular/CuilTitular,0,2) eq '34')`
                case 7: return `(ActaEnviadaEmail eq false or ActaEnviadaEmail eq null)`;
            }
        });
        options.unshift([`LoteImpresionId eq ${loteImpresionId}`]);
        const $filter = [...options].join(" and ");
        const $query = [`$filter=${$filter}`].join("");
        try {
            const response = await api.getLoteByParameter($query, soloTxt, soloPdf);
            if (response && response.data) {

                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = URL.createObjectURL(blob);
        
                // Obtener el nombre del archivo desde el header 'content-disposition'
                const contentDisposition = response.headers['content-disposition'];
                let filename = 'Actas por parametros.zip';
                if (contentDisposition && contentDisposition.includes('filename=')) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }
        
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
        
                URL.revokeObjectURL(url);
                document.body.removeChild(a);
            } else {
                console.error('La respuesta no contiene el archivo.');
            }
        } catch (error) {
            console.error('Error al descargar el archivo:', error);
        } finally {
            setIsModalElegirDescarga(false);
        }
    }

    return (
        <MainLayout maxContentWidth={90} > 

            <ModalElegirDescarga 
                isOpen={isModalElegirDescarga} 
                onCancel={() => setIsModalElegirDescarga(false)} 
                onClick={descargarActasSeleccion}
                loading={loading}/>

            <StyledModal
                width={"85%"}
                footer={null}
                open={isModalImpresionCheckVisible}
                onCancel={() => {
                    setIsModalImpresionCheckVisible(false);
                }}
                afterClose={async () => {
                    await refFiltroInfracciones.current.loadTotal()
                    await refTable.current.loadItems()
                }}
                destroyOnClose
            >
                <LoteImpresionCheck
                    list={async () => {
                        const result = await apiInfraccionesImpresion.listInfraccionesParaImpresion({
                            ...query,
                            ...{ $expand: ["Titular"] }
                        }, filtersReincidencia!)

                        const infracciones = result.data?.value || [];
                        const ids = infracciones.map((infraccion) => infraccion.Id);
                        setInfraccionesIds(ids);
                        return result;
                    }}
                    query={query}
                    agenteFirmanteId={agenteFirmanteId}
                    empresaCorreoId={toInteger(empresaCorreoId)}
                    FilterReincidencias={filtersReincidencia}
                    onGenerateLoteCloseModal={(showModal) => setIsModalImpresionCheckVisible(showModal)}
                    ref={refCheckLote}
                    infraccionesIds={infraccionesIds}
                    unidadesProdNombres={unidadesProdNombres}
                />
            </StyledModal>
            {/* El componente Space le daba un scroll innecesario a la tabla */}
            {/* <Space size={"large"} direction="vertical"> */}

                <FiltroInfracciones
                    ubicacionInfractorFilter
                    ciudadesInfractorFilter
                    ref={refFiltroInfracciones}
                    onChange={(query) => {
                        setQuery(query);
                    }}
                    onChangeCount={(count) => {
                        setTotal(count);
                    }}
                    onChangeLoading={(loading) => {
                        setLoading(loading);
                    }}
                    onChangeUnidadesProd={(ids) => {
                        setSelectedUnidadesProduccion(ids)
                    }}
                    count={async (query) => {
                        return await infraccionesRadarApi.getReadyToPrintCount(query, filtersReincidencia!);
                    }}
                >

                    <Form.Item label="Empresa correo" style={{ marginBottom: 0 }}>
                        <Select
                            style={{ width: "150px" }}
                            loading={!empresasCorreoResponse}
                            value={empresaCorreoId}
                            onChange={(value) => setEmpresaCorreoId(value)}
                        >
                            {empresasCorreoResponse?.data?.value.map((correo: EmpresaCorreo) => (
                                <Select.Option key={correo.id} value={correo.id}>
                                    {correo.nombre}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="Agente firmante" style={{ marginBottom: 0 }}>
                        <Select
                            style={{ width: "180px" }}
                            loading={!agentesResponse}
                            value={agenteFirmanteId}
                            allowClear
                            onChange={(value) => setAgenteFirmanteId(value)}
                        >
                            {agentesResponse?.data?.value.map((agente: Agente) => (
                                <Select.Option key={agente.Id} value={agente.Id}>
                                    {agente.Nombre} {agente.Apellido}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Button
                        loading={loading}
                        type="primary"
                        onClick={async () => {
                            setIsModalImpresionCheckVisible(true);
                        }}
                        icon={<FilePdfOutlined />}
                        disabled={!total ? true : false}
                    >
                        Seleccionar infracciones
                    </Button>

                </FiltroInfracciones>

                <Form
                    onValuesChange={async () => {
                        setfiltersReincidencia(form.getFieldsValue())
                    }}
                    form={form}
                >
                    <div style={{ marginBottom: "1em" }}>
                        <Collapse style={{ width: '100%', backgroundColor: '#e0e0e0' }} accordion bordered={false}>
                            <Collapse.Panel header={genStrongText("Filtros reincidencia")} key="filtros_rein">
                                <strong style={{ paddingRight: '0.5rem' }}>Preseleccionar</strong>
                                <Select onClear={() => {
                                    form.resetFields();
                                    setfiltersReincidencia(null);
                                }} onChange={(value) => onChangePreFiltro(value)} placeholder="Seleccione un filtro" showSearch allowClear style={{ width: "200px" }}>
                                    <Select.Option value={1}>
                                        Entrerrianos hasta 2 infracciones en 90 dias, 4 en total
                                    </Select.Option>
                                </Select>
                                <FiltroReincidencia>
                                    <Form.Item name={"LimiteInfraccionesTotal"} style={{ marginBottom: 0, marginTop: '1rem' }} label="Limite infracciones total">
                                        <InputNumber />
                                    </Form.Item>
                                    <Form.Item name={"DiasPeriodo"} style={{ marginBottom: 0, marginTop: '1rem' }} label="Periodo (dias)">
                                        <InputNumber />
                                    </Form.Item>
                                    <Form.Item name={"LimiteInfraccionesPeriodo"} style={{ marginBottom: 0 }} label="Limite infracciones por periodo">
                                        <InputNumber />
                                    </Form.Item>
                                    <b></b>
                                    <Form.Item
                                        label="Provincia infractor"
                                        name={"ProvinciaTitular"}
                                        style={{ marginBottom: 0 }}>
                                        <Select disabled={form.getFieldValue("CodigoPostalTitular")} placeholder="Seleccione una provincia" showSearch allowClear style={{ width: "180px" }}>
                                            {getProvinciasList().map((province, index) => (
                                                <Select.Option key={index} value={province}>
                                                    {province}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item name={"CodigoPostalTitular"} style={{ marginBottom: 0 }} label="Codigo postal infractor">
                                        <InputNumber disabled={form.getFieldValue("ProvinciaTitular")} />
                                    </Form.Item>
                                </FiltroReincidencia>
                            </Collapse.Panel>
                        </Collapse>
                    </div>
                </Form>

                <DataTableStyled>
                <DataTable<LoteImpresion, LoteImpresion>
                    list={(query) => api.list({
                        ...query,
                        ...{
                            $expand: ['AgenteFirmante']
                        }
                    })}
                    delete={async (id) => {
                        const result = await api.delete(id);
                        await refFiltroInfracciones.current.loadTotal();
                        return result;
                    }}
                    deleteMultipleAction
                    defaultSortOrder={"NroLote desc"}
                    selectionType='checkbox'
                    title={"Lotes de impresión"}
                    generateFilters={generateFilters}
                    rowClassName={onRowClassName}
                    deleteItemAction
                    deleteItemActionConfirmMessage={(item) => `¿Eliminar lote ${item.NroLote}?`}
                    defaultPageSize={5}                    
                    tableActions={[
                        {
                            key: 'download',
                            label: 'Descargar impresor',
                            action: downloadPrinter,
                            icon: <PrinterOutlined />
                        }
                    ]}
                    itemActions={[
                        {
                            key: 'download',
                            label: "Descargar",
                            checkDisabled: (selectedItems, index, items) => !items?.at(index)?.UrlLoteComprimido,
                            action: (item) => {
                                window.location.href = item.UrlLoteComprimido!;
                            },
                            icon: <DownloadOutlined />
                        },
                        {
                            key: 'send-callcenter',
                            label: "Enviar a Call Center",
                            checkDisabled: (selectedItems, index, items) => !items?.at(index)?.UrlLoteComprimido,
                            action: async (item) => {
                                Modal.confirm({
                                    title: "Confirmar envio de lote",
                                    content: `¿Desea hacer disponible el lote ${item.Id} para Call Center?`,
                                    width: 320,
                                    maskClosable: true,
                                    okText: "Confirmar",
                                    cancelText: "Cancelar",
                                    onOk: async () => {
                                        sendLoteToCallCenter(item.Id);                                        
                                    }
                                })
                            },
                            icon: <SendOutlined />
                        },
                        {
                            key: 'descarga-por-seleccion',
                            label: "Descargar según parámetros",
                            checkDisabled: (selectedItems, index, items) => !items?.at(index)?.UrlLoteComprimido,
                            action: async (item) => {
                                setLoteImpresionId(item.Id);
                                setIsModalElegirDescarga(true);
                            },
                            icon: <DownloadOutlined />
                        }
                    ]}
                    ref={refTable}

                >

                    <Table.Column<LoteImpresion>
                        width={`20%`}
                        title="Fecha"
                        dataIndex={"FechaHora"}
                        sorter
                        render={(value, record, index) => moment(value).format("DD/MM/YYYY HH:mm:ss")}
                        sortDirections={["ascend", "descend", "ascend"]}

                    />

                    <Table.Column<LoteImpresion>
                        width={`${65 * 0.1}%`}
                        title="Nro. de lote"
                        dataIndex={"NroLote"}
                        sorter
                        defaultSortOrder={'descend'}
                        sortDirections={["ascend", "descend", "ascend"]}
                        filterDropdown={(props) => {
                            return (
                                <DataFilter filterDropdownProps={props} form={nroLoteFilterForm} >
                                    <Form.Item name={"NroLote"} style={{ marginBottom: 10 }}>
                                        <Input placeholder='Nro. de lote...' />
                                    </Form.Item>
                                </DataFilter>
                            );
                        }
                        }
                    />
                    <Table.Column<LoteImpresion>
                        width={`${25 * 0.1}%`}
                        title="Cantidad"
                        dataIndex={"CantidadInfracciones"}                        
                        render = {(value, record) => {                            
                            return(
                                <ImpresionesStyled>
                                    {
                                        record.CantidadInfracciones
                                    }
                                </ImpresionesStyled>
                            )
                        }}
                    />
                    <Table.Column<LoteImpresion>
                        width={`${25 * 0.1}%`}
                        title="Excluidas"
                        dataIndex={"CantidadInfraccionesExcluidas"}                        
                        render={(value, record) => {
                            return(
                                <ImpresionesStyled className = "red">
                                    {
                                        record.CantidadInfraccionesExcluidas != null ? record.CantidadInfraccionesExcluidas : "-"
                                    }
                                </ImpresionesStyled>
                            )
                        }}
                    />
                    <Table.Column<LoteImpresion>
                        width={`${25 * 0.1}%`}
                        title="Regeneradas"
                        dataIndex={"CantidadRegeneradas"}                        
                        render={(value, record) => {                            
                            return(
                                <ImpresionesStyled className = "blue">
                                    {
                                        record.CantidadInfraccionesRegeneradas != null ? record.CantidadInfraccionesRegeneradas : "-"
                                    }
                                </ImpresionesStyled>
                            )
                        }}
                    />
                      <Table.Column<LoteImpresion>
                        width={`${25 * 0.1}%`}
                        title="Impresas"
                        dataIndex={"CantidadImpresas"}                        
                        render={(value, record) => {                            
                            return(
                                <ImpresionesStyled className = "green">
                                    {
                                        (record.CantidadInfracciones ?? 0) - (record.CantidadInfraccionesExcluidas ?? 0) - (record.CantidadInfraccionesRegeneradas ?? 0)
                                    }
                                </ImpresionesStyled>
                            )
                        }}
                    />
                    <Table.Column<LoteImpresion>
                        width={`20%`}
                        title="Unidad de producción"
                        dataIndex={"UnidadesProdNombre"}
                        sorter
                        defaultSortOrder={'descend'}
                        sortDirections = {["ascend", "descend", "ascend"]}
                        filterDropdown={(props) => {
                            return (
                                <DataFilter filterDropdownProps={props} form={uProduccionFilterForm}>
                                    <Form.Item name={"UnidadesProdNombre"} style={{ marginBottom: 10 }}>
                                        <Input placeholder='Unidad de producción...' />
                                    </Form.Item>
                                </DataFilter>
                            );
                        }}
                    />


                    <Table.Column<LoteImpresion>
                        width={`20%`}
                        title="Agente firmante"
                        dataIndex={"AgenteFirmante"}
                        render={(value, record) => (
                            {
                                props: {
                                    style: { color: !record.AgenteFirmante ? '#e53935' : 'inherit' }
                                },
                                children: <span>{record.AgenteFirmante ? `${record.AgenteFirmante!.Apellido} ${record.AgenteFirmante!.Nombre}` : 'Correspondiente al equipo'}</span>
                            }
                        )}

                    />
                    <Table.Column<LoteImpresion>
                        width={`18%`}
                        title="Fecha de envío call center"
                        dataIndex={"FechaHoraCallCenter"}
                        sorter
                        render={(value, record, index) => {                            
                            if (record.FechaHoraCallCenter?.split("-")[0] === "0001" || record.FechaHoraCallCenter == null) {
                                return <div style = {{ textAlign: "center" }}> - </div>
                            }
                            else {
                                return <div>{ moment(record.FechaHoraCallCenter).format("DD/MM/YYYY HH:mm:ss") }</div>
                            }
                        }}
                        sortDirections={["ascend", "descend", "ascend"]}
                    />
                </DataTable>
                </DataTableStyled>
            {/* Fin del componente Space */}
            <Form style={{ marginTop: 25 }} onFinish={queryImportPdf}>
                <Typography.Title level={4}>Importación</Typography.Title>
                <Space style={{ justifyContent: 'center' }}>
                    <Form.Item
                        name={"tipoImportacion"}
                        required label="Seleccione el tipo de importación:" rules={[{ required: true, message: "Campo requerido" }]}>
                        <Select<TipoExportacion>
                            allowClear
                            placeholder="Tipo de importación" style={{ width: "200px" }}>
                            <Select.Option value={"PROTOCOLO_BA" as TipoExportacion}>Protocolo BS. AS.</Select.Option>
                        </Select>
                    </Form.Item>
                </Space>
                <Button
                    htmlType="submit"
                    style={{ marginLeft: 30 }}
                    loading={loadingImportPDF}
                    type="primary"
                    icon={<FilePdfOutlined />}
                >
                    Enviar
                </Button>
            </Form>
        </MainLayout>
    );
};